import React, { useState } from 'react';
import { PrivacyModal } from './PrivacyModal';
import { ShieldCheckIcon } from 'lucide-react';
export function Footer() {
  const [privacyOpen, setPrivacyOpen] = useState(false);
  return <>
      <footer className="bg-ink text-white/60 py-10 text-center text-sm" data-id="element-52">
        <div className="max-w-4xl mx-auto px-4 space-y-4" data-id="element-53">
          <p className="text-white/40 font-heading text-lg" data-id="element-54">
            Cero Inflamación 7D
          </p>

          <div className="flex items-center justify-center gap-4" data-id="element-55">
            <button onClick={() => setPrivacyOpen(true)} className="inline-flex items-center gap-1.5 text-white/50 hover:text-accent transition-colors cursor-pointer underline underline-offset-2 decoration-white/20 hover:decoration-accent" data-id="element-56">
              <ShieldCheckIcon className="w-3.5 h-3.5" data-id="element-57" />
              Política de Privacidad
            </button>
          </div>

          <p className="text-white/40 text-xs" data-id="element-58">
            © {new Date().getFullYear()} Cero Inflamación 7D. Todos los
            derechos reservados.
          </p>

          <p className="text-xs text-white/25 max-w-2xl mx-auto leading-relaxed" data-id="element-59">
            Descargo de responsabilidad: La información contenida en este sitio
            web y en el protocolo es solo para fines educativos y no pretende
            sustituir el consejo, diagnóstico o tratamiento médico profesional.
          </p>
        </div>
      </footer>

      <PrivacyModal isOpen={privacyOpen} onClose={() => setPrivacyOpen(false)} data-id="element-60" />
    </>;
}